import Vue from 'vue';
import FrontendRoot from './FrontendRoot.vue';
import router from './router';
import Buefy from 'buefy';
import './main.css';
import { COLORS } from '@frontend/ui/Constants';

import initializeSentry from '@frontend/shared/monitoring.js';
initializeSentry(Vue);

Vue.use(Buefy);

import Oruga from '@oruga-ui/oruga';
import '@oruga-ui/oruga/dist/oruga-full-vars.css';
import '@frontend/ui/oruga-defaults.css';
Vue.use(Oruga, { iconPack: 'fas' });

import { createPinia, PiniaVuePlugin } from 'pinia';
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// Remove this line
// import 'inter-ui/inter.css';

// Remove this line if it exists
// import 'dm-sans/dist/dm-sans.css';

// don't render if code outside of the ui bundle is trying to load but not render the bundle
if (!!window.__SHOULD_SKIP_UI_BUNDLE_RENDERING) {
  console.log('__SHOULD_SKIP_UI_BUNDLE_RENDERING set to true, skipping render of ui bundle.');
} else {
  const getRootData = function() {
    const { STATIC_ROOT, AI_ENDPOINT_URL, WEBSOCKET_URL } = JSON.parse(document.getElementById('JS_BOOTSTRAP').textContent);
    return {
      STATIC_ROOT,
      AI_ENDPOINT_URL,
      WEBSOCKET_URL,
      COLORS,
      csrfToken: document.querySelector('[name="csrfmiddlewaretoken"]').value,
      isEmbed: false,
    };
  };

  new Vue({
    el: '#frontend-root',
    router,
    pinia, // Make sure this line is present
    components: { FrontendRoot },
    data: getRootData,
    template: '<FrontendRoot/>',
    render: h => h(FrontendRoot),
  });
}
